import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import StickyTable from "../../components/common/StickyTable";
import {
  INCOMES_LIST,
  INCOMES_EDIT,
  INCOMES_DELETE,
  INCOME_CATEGORY_LIST_DROPDOWN,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
} from "../../routes/routes";
import { PAGINATE, NOPAGINATE, INCOME_DELETED } from "../../constant/constant";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import {
  styleExcelHeaderRow,
  styleExcelSummaryRow,
} from "../../utils/excelStyles";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
  hasRole,
} from "../../components/Utils";
import Loader from "../../components/common/Loader";
import { Modal, Image } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import { Link } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import { glassSelectStyles } from "../../constant/selectStyles";

const IncomesList = () => {
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);

  const [filter, setFilter] = useState({
    country_id: null,
    state_id: null,
    region_id: null,
    chapter_id: null,
    category_id: null,
    from_date: "",
    to_date: "",
  });

  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [categoryOptions, setCategoryOptions] = useState({});

  const [showClearBtn, setShowClearBtn] = useState(false);
  const [btnExcelDisabled, setBtnExcelDisabled] = useState(false);

  const refFlatpickr = useRef(null);
  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const { hasPermission } = usePermission();

  const HandleDelete = async (id) => {
    try {
      axios.delete(INCOMES_DELETE + id).then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(INCOME_DELETED);
          setRefresh((prev) => !prev);
        }
      });
    } catch (error) {
      console.error("Error deleting income:", error);
    }
  };

  //excel export start
  const columns = [{ header: "Sl.No.", key: "sno" }];
  if (hasRole([1])) {
    columns.push({ header: "Country", key: "country_name" });
  }
  if (hasRole([1, 6])) {
    columns.push({ header: "State", key: "state_name" });
  }
  if (hasRole([1, 6, 7])) {
    columns.push({ header: "Region", key: "region_name" });
  }
  if (hasRole([1, 6, 7, 2])) {
    columns.push({ header: "Chapter", key: "chapter_name" });
  }
  columns.push(
    { header: "Category", key: "income_category_name" },
    { header: "Amount", key: "formatted_amount" },
    { header: "Date", key: "date" },
    { header: "Members Count", key: "members_count" },
    { header: "Notes", key: "notes" },
  );

  const { from_date, to_date } = filter;
  let workSheetName = "Incomes";
  if (from_date && to_date) {
    workSheetName += ` (${moment(from_date).format("DD-MM-YYYY")} to ${moment(to_date).format("DD-MM-YYYY")})`;
  }
  const workBookName = "Incomes List";
  const workbook = new Excel.Workbook();

  const exportAsExcel = async () => {
    try {
      const fileName = workBookName;
      const worksheet = workbook.addWorksheet(workSheetName);
      worksheet.columns = columns;
      const headerRow = worksheet.getRow(1);
      styleExcelHeaderRow(headerRow, columns.length);
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 15;
        column.alignment = { horizontal: "center" };
      });
      setBtnExcelDisabled(true);
      await axios
        .get(INCOMES_LIST, {
          params: { paging_type: NOPAGINATE, isAdmin: 1, ...filter },
        })
        .then(async (response) => {
          if (response.status === 200 && response.data.success) {
            const excelData = response.data.data.incomes;
            const totalAmount = response.data.data.total_income_amount;
            if (excelData.length < 1) {
              toast.error("No data found!");
              return;
            }
            excelData.forEach((singleData) => {
              worksheet.addRow({
                ...singleData,
                members_count: singleData.member_ids?.length || 0,
              });
            });
            // Total row
            let totalRow = { sno: "" };
            if (hasRole([1])) {
              totalRow.country_name = "";
            }
            if (hasRole([1, 6])) {
              totalRow.state_name = "";
            }
            if (hasRole([1, 6, 7])) {
              totalRow.region_name = "";
            }
            if (hasRole([1, 6, 7, 2])) {
              totalRow.chapter_name = "";
            }
            totalRow.income_category_name = "Total";
            totalRow.formatted_amount = totalAmount;
            totalRow.date = "";
            totalRow.members_count = "";
            totalRow.notes = "";
            worksheet.addRow(totalRow);
            const lastRow = worksheet.lastRow;
            styleExcelSummaryRow(lastRow, columns.length);
            worksheet.eachRow({ includeEmpty: false }, (row) => {
              row._cells.forEach((singleCell) => {
                worksheet.getCell(singleCell._address).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              });
            });
            const buf = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buf]), `${fileName}.xlsx`);
          }
        })
        .finally(() => {
          setBtnExcelDisabled(false);
        });
    } catch (error) {
      console.error("Export error:", error);
      toast.error(error.message);
    } finally {
      workbook.removeWorksheet(workSheetName);
    }
  };
  //excel export end

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    if (refFlatpickr.current && refFlatpickr.current.flatpickr) {
      refFlatpickr.current.flatpickr.setDate([]);
    }
    setFilter({
      ...filter,
      from_date: "",
      to_date: "",
    });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(INCOMES_LIST, {
        params: {
          type: PAGINATE,
          paging_type: "paginate",
          page: page,
          perPage: perPage,
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.incomes || []);
          setPaginator({
            prev: response.data.data.prev != null,
            next: response.data.data.next != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .catch((err) => {
        toast.error("Error fetching incomes list");
      })
      .finally(() => {
        setLoading(false);
      });

    const fetchData = async () => {
      try {
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        setCountryOptions(countryResponse.data.data);

        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setStateOptions(stateResponse.data.data);

        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setRegionOptions(regionResponse.data.data);

        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setChapterOptions(chapterResponse.data.data);

        const categoryResponse = await axios.get(INCOME_CATEGORY_LIST_DROPDOWN);
        setCategoryOptions(categoryResponse.data.data);
      } catch (error) {
        console.error("Error fetching dependencies:", error);
      }
    };
    fetchData();
  }, [page, filter, perPage, refresh]);

  const handleCalendarClick = () => {
    if (refFlatpickr.current) {
      refFlatpickr.current.flatpickr.open();
    }
  };

  const openDetailsModal = async (inc) => {
    setDetailData(inc);
    setDetailModal(true);
    setDetailLoading(true);
    try {
      const response = await axios.get(`${INCOMES_EDIT}${inc.id}`);
      if (response.status === 200 && response.data.success) {
        setDetailData(response.data.data);
      }
    } catch (err) {
      toast.error("Failed to load full income details.");
    } finally {
      setDetailLoading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-3">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Incomes</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Incomes List</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              {hasPermission("incomes-list-export") && (
                <div className="pt-btn">
                  <button
                    disabled={btnExcelDisabled}
                    type="button"
                    onClick={exportAsExcel}
                    className="btn rounded-pill btn-primary excel-btn ibutton"
                  >
                    <span className="tf-icons bx bxs-spreadsheet"></span>&nbsp;
                    Excel
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1">
        <div className="filter-card">
          <h6 className="filter-card-title">Search &amp; Filter</h6>

            <div className="row mb-4 gx-3">
              {hasRole([1]) && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <label className="filter-label">Country</label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      setFilter({
                        ...filter,
                        country_id: selected?.value || null,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <label className="filter-label">State</label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      setFilter({
                        ...filter,
                        state_id: selected?.value || null,
                        region_id: null,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mb-3">
                    <label className="filter-label">Region</label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={glassSelectStyles}
                      ref={selectRegionRef}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({
                          ...filter,
                          region_id: selected?.value || null,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 2]) && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mb-3">
                    <label className="filter-label">Chapter</label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={glassSelectStyles}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      onChange={(selected) =>
                        setFilter({
                          ...filter,
                          chapter_id: selected?.value || null,
                        })
                      }
                    />
                  </div>
                </div>
              )}

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="mb-3">
                  <label className="filter-label">Category</label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    name="category_id"
                    isClearable
                    options={categoryOptions}
                    onChange={(selected) =>
                      setFilter({
                        ...filter,
                        category_id: selected?.value || null,
                      })
                    }
                    placeholder="All Categories"
                  />
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="filter-label" htmlFor="date_range">
                    Date Range
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickr}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              setFilter({
                                ...filter,
                                from_date: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                to_date: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearBtn(false);
                            }
                          },
                        }}
                        placeholder="Date Range"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
        </div>
            {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}

        <div className="card icard sticky-table-card">
          

          
          <StickyTable refreshDeps={[data, loading]}><table className="table table-striped itable sticky-action-col">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                  <th>Category</th>
                  <th>Amount</th>
                  <th>Date</th>
                  <th>Members</th>
                  <th style={{ textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="10" />
                ) : data.length > 0 ? (
                  data.map((inc, i) => (
                    <tr key={i}>
                      <td>{inc?.sno}</td>
                      {hasRole([1]) && <td>{inc?.country_name}</td>}
                      {hasRole([1, 6]) && <td>{inc?.state_name}</td>}
                      {hasRole([1, 6, 7]) && <td>{inc?.region_name}</td>}
                      {hasRole([1, 6, 7, 2]) && <td>{inc?.chapter_name}</td>}
                      <td>{inc?.income_category_name}</td>
                      <td className="fw-bold text-success-dark">
                        {inc?.formatted_amount}
                      </td>
                      <td>{inc?.date}</td>
                      <td>{inc?.member_ids?.length || 0}</td>
                      <td style={{ textAlign: "center" }}>
                        {hasPermission("incomes-list") && (
                          <button
                            className="badge bg-label-info me-1 border-0"
                            title="View Details"
                            onClick={() => openDetailsModal(inc)}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        )}
                        {hasPermission("incomes-edit") && (
                          <Link to={`/incomes/${inc.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}
                        {hasPermission("incomes-delete") && (
                          <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message: "Are you sure, you want to delete?",
                                fn: () => HandleDelete(inc?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="10" message="No incomes found" />
                )}
              </tbody>
            </table>
          </StickyTable>

          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={detailsModal}
        size="lg"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="modal_title1">Income Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {detailLoading ? (
            <Loader loading={true} colspan="1" />
          ) : (
            <div className="card-body py-0">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label m-0">Category</label>
                  <span className="d-block font-weight-600 mt-1">
                    {checkEmptyOrNull(detailData?.income_category_name)}
                  </span>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label m-0">Amount</label>
                  <span className="d-block font-weight-600 mt-1 text-success-dark">
                    {checkEmptyOrNull(detailData?.formatted_amount)}
                  </span>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label m-0">Date</label>
                  <span className="d-block font-weight-600 mt-1">
                    {checkEmptyOrNull(detailData?.date)}
                  </span>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label m-0">
                    Region & Chapter Location
                  </label>
                  <span className="d-block font-weight-600 mt-1">
                    {detailData?.region_name
                      ? detailData?.region_name + " / "
                      : ""}
                    {checkEmptyOrNull(detailData?.chapter_name)}
                  </span>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label m-0">Members</label>
                  <span className="d-block font-weight-600 mt-1">
                    {detailData?.members && detailData?.members.length > 0 ? (
                      detailData.members.map((member, idx) => (
                        <span key={idx} className="badge bg-label-primary me-1">
                          {member.name} - {member.company_name}
                        </span>
                      ))
                    ) : (
                      <span className="text-muted fs-7">No Members Linked</span>
                    )}
                  </span>
                </div>

                <div className="col-md-12">
                  <div className="mb-4">
                    <label className="form-label m-0">Notes</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData?.notes)}
                    </span>
                  </div>
                </div>

                {detailData?.attachments &&
                  detailData?.attachments.length > 0 && (
                    <div className="col-md-12 mb-3">
                      <label className="form-label m-0">Attachments</label>
                      <div className="d-flex flex-wrap mt-2 gap-2">
                        {detailData?.attachments &&
                        detailData?.attachments.length > 0 ? (
                          detailData.attachments.map((file, idx) => (
                            <a
                              key={idx}
                              href={file}
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-sm btn-outline-primary d-flex align-items-center"
                            >
                              <i className="bx bx-paperclip me-1"></i>{" "}
                              {file.substring(0, 20)}...
                            </a>
                          ))
                        ) : (
                          <span className="text-muted fs-7">
                            No Attachments
                          </span>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#163586"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                setConfirmationModal(false);
                confirmation?.fn?.();
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default IncomesList;
